import { ChangeDetectionStrategy, Component, computed, effect, EventEmitter, inject, Input, OnInit, Output, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { Popover, PopoverModule } from 'primeng/popover';
import { concatMap, finalize, from, tap } from 'rxjs';
import { AuthService, FichajeService } from 'src/app/shared/services';
import { DialogModule } from 'primeng/dialog';
import { FichajeStartComponent } from "../fichaje-start/fichaje-start.component";
import { FichajeSessionEvent } from 'src/app/shared/interfaces/session-event.interface';
import { FichajeEndworkComponent } from "../fichaje-endwork/fichaje-endwork.component";


@Component({
  selector: 'app-employee-avatar-fichaje-info',
  imports: [AvatarModule, PopoverModule, DividerModule, ButtonModule, DialogModule, FichajeStartComponent, FichajeEndworkComponent],
  templateUrl: './employee-avatar-fichaje-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmployeeAvatarFichajeInfoComponent implements OnInit{

  @ViewChild('op') op:Popover;
  
  @Input({required: true}) isMobile!:boolean;
  @Output() onDrawerlose = new EventEmitter<boolean>();

  private authService = inject( AuthService );
  private fichajeService = inject( FichajeService );
  private router = inject( Router );
  public user = computed(() => this.authService.currentUser() );

  private fichajeRefresh = computed(() => this.fichajeService.fichajeRefresh());

  constructor() { 
    effect(() => {
      if(this.fichajeRefresh()) {
        this.loadData();
        this.fichajeService.resetFichajeRefresh();
      }
    }
    )
  }

  public roleName:string;

  visible: boolean = false;

    showDialog() {
        this.visible = true;
    }

  public sugerirFichajeEntrada = signal<boolean>(false);
  public sugerirFichajeSalida = signal<boolean>(false);

  public isLoading = signal<boolean>(true);

    public lastFichaje = signal<FichajeSessionEvent | null>(null);
  

  ngOnInit(): void {
    this.roleName = this.assignRoleName();  
    this.loadData();
    
  }

  goToMyProfile() {
    this.router.navigate(['app', 'employees' , 'my-profile', this.user()!.uid]);
    if(this.isMobile) this.onDrawerlose.emit(false);
    else
      this.op.hide();
  }

  onEntradaRegistrada() {
    this.visible = false;
    this.loadData();
  }

  async signout() {
    await this.authService.logout().then(() => this.router.navigate(['/auth/login']))
    
  }

  assignRoleName():string {
    switch (this.user()?.role) {
      case 'super':
        return 'Súperadministrador'
      case 'admin': 
        return 'Administrador'
      case 'user':
        return 'Empleado'
      case 'manager':
        return 'Gerente'
      default:
        return 'Desconocido'
    }
  }

   loadData(): void {
    this.isLoading.set(true);
    
    from(this.fichajeService.sugerirFichajeEntrada(this.user()!.uid)).pipe(
      tap((res) => this.sugerirFichajeEntrada.set(res)),
      concatMap(() => from(this.fichajeService.tieneFichajePendienteSalida(this.user()!.uid))),
      tap((res) => this.sugerirFichajeSalida.set(res)),
      concatMap(() => from(this.fichajeService.getUltimoFichaje(this.user()!.uid))),
      tap((res) => this.lastFichaje.set(res)),
      finalize(() => this.isLoading.set(false))
    ).subscribe();
  }

 }
